import {PortableText, PortableTextComponents} from '@portabletext/react'
import { RichTextSanityImage } from './rich-text-image'
import { SectionDefaultProps } from '#app/types/type.ts'
import { RichTextSection } from '#app/types/schema.ts'
import { Link } from 'react-router'
import { stegaClean } from '@sanity/client/stega'
import { resolveInternalLinkUrl } from '#app/utils/misc.tsx'
import { Heading } from './text'

type ContentProps = SectionDefaultProps & {
  data: RichTextSection
}

export const richTextComponents: PortableTextComponents = {
  types: {
    image: RichTextSanityImage,
  },
  marks: {
    link: ({ children, value }) => {
      const href = value?.href || '';
      const isExternal = href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:');
      const openInNewTab = value?.blank === true; // Check the 'blank' property fetched via GROQ

      return (
          <Link 
          to={href} 
          className="text-primary hover:underline" 
          prefetch={isExternal ? 'intent' : undefined}
          target={isExternal ? '_blank' : undefined}
          rel={isExternal ? 'noopener noreferrer' : undefined}
          >
              {children}
          </Link>
      );
    },
    internalLink: ({ children, value }) => {
        // 'value' now contains { _key, _type: 'internalLink', reference: {...}, slug: '...', docType: '...' }
        // thanks to the GROQ query modification.
        const urlPath = resolveInternalLinkUrl(value?.docType, value?.slug);

        if (!urlPath) {
            // Fallback for missing link data or unhandled type
            return <span className="text-red-500 italic">(Invalid Link) {children}</span>;
        }

        return (
            <Link to={urlPath} className="text-primary hover:underline" prefetch="intent">
                {children}
            </Link>
        );
    },
    customPathLink: ({ children, value }) => {
        const path = value?.path;

        if (!path) {
          // Fallback if path is missing
          return <span className="text-red-500 italic">(Invalid Custom Link Path) {children}</span>;
        }

        // Use React Router Link with the predefined path
        return (
          <Link to={path} className="text-primary hover:underline" prefetch="intent">
            {children}
          </Link>
        );
    },
  }
}

export function SanityContent(props: ContentProps) {
  const {data} = props
  const richText = stegaClean(data);
  const { heading, headingLevel, content } = richText;
  return (
    <div className='container'>
        {heading && (
            <Heading as={headingLevel}>
                {heading}
            </Heading>
        )}
        <div className="prose dark:prose-invert max-w-7xl">
            {heading && (
                <p> <br /> </p>
            )}
            <PortableText value={content} components={richTextComponents} />
        </div>
    </div>
  )
}